import _ from 'lodash';
import {
  useState,
  useEffect,
} from 'react';
import {
  quranQuotesUpdateRawFile,
} from '../../services/api-v1-services/other-services';

const updateQuranQuotes = () => {
  const [ responseData, setResponseData ] = useState({ });
  const [ updateData, setUpdateData ] = useState(null);
  const {
    items,
    onOperationComplete,
  } = updateData || {};

  const updateQuotes = async () => {
    try {
      console.log(`Updating quran quotes...`);
      setResponseData({
        isUpdating: true,
        isError: false,
      });

      const quranQuotesUpdateApiResp = await quranQuotesUpdateRawFile({
        quran_quotes: items,
      });
      const responseData = quranQuotesUpdateApiResp.data;

      let errorMsg = null;
      let isError = false;

      if(responseData.success) {
        console.log('Quran quotes update Success!!');
      } else {
        console.log('Quran quotes update  Failed!!');
        errorMsg = `Failed to update quran quotes!`;
        isError = true;
      }

      setResponseData({
        isUpdating: false,
        isError,
        errorMsg,
        data: responseData.data,
      });

      if(onOperationComplete) {
        onOperationComplete({
          isError,
          errorMsg,
          data: responseData.data,
        });
      }
    } catch (err) {
      console.log('Something went wrong while updating quran quotes. ', err);
      const errorMsg = `Error occurred while  updating quran quotes.`;
      setResponseData({
        isUpdating: false,
        isError: true,
        errorMsg,
        data: null,
      });
      if(onOperationComplete) {
        onOperationComplete({
          isError: true,
          errorMsg,
          data: null,
        });
      }
    }
  };

  useEffect( () => {
    if(!_.isEmpty(updateData)) {
      updateQuotes();
    }
  }, [ updateData ]);

  return [
    responseData,
    setUpdateData,
  ];
};

export default updateQuranQuotes;
